/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BillingSummary } from '../models/BillingSummary';
import type { PlanUpdate } from '../models/PlanUpdate';
import type { ROISummary } from '../models/ROISummary';
import type { UserResponse } from '../models/UserResponse';
import type { UserUpdate } from '../models/UserUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
    /**
     * Get User Me
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public static getUserMeApiV1UsersMeGet(): CancelablePromise<UserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users/me',
        });
    }
    /**
     * Update User Me
     * Update current user profile and preferences
     * @param requestBody
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public static updateUserMeApiV1UsersMePut(
        requestBody: UserUpdate,
    ): CancelablePromise<UserResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/users/me',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update User Plan
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateUserPlanApiV1UsersMePlanPost(
        requestBody: PlanUpdate,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/users/me/plan',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Billing Summary
     * @returns BillingSummary Successful Response
     * @throws ApiError
     */
    public static getBillingSummaryApiV1UsersMeBillingGet(): CancelablePromise<BillingSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users/me/billing',
        });
    }
    /**
     * Get Roi Summary
     * @returns ROISummary Successful Response
     * @throws ApiError
     */
    public static getRoiSummaryApiV1UsersMeRoiGet(): CancelablePromise<ROISummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users/me/roi',
        });
    }
    /**
     * List Users
     * @param skip
     * @param limit
     * @param includeAdmins
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public static listUsersApiV1UsersGet(
        skip?: number,
        limit: number = 100,
        includeAdmins: boolean = false,
    ): CancelablePromise<Array<UserResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users/',
            query: {
                'skip': skip,
                'limit': limit,
                'include_admins': includeAdmins,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get User
     * @param userId
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public static getUserApiV1UsersUserIdGet(
        userId: number,
    ): CancelablePromise<UserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update User
     * @param userId
     * @param requestBody
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public static updateUserApiV1UsersUserIdPut(
        userId: number,
        requestBody: UserUpdate,
    ): CancelablePromise<UserResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/users/{user_id}',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete User
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteUserApiV1UsersUserIdDelete(
        userId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/users/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
